import { shade } from 'polished'
import styled from 'styled-components'

import {
  BaseButton,
  type IBaseButtonProps,
} from '../../../../elements/Button/BaseButton'
import { applyButtonColorCSS } from '../../../../elements/Button/styles/utils'

export interface IButtonGroupButtonProps extends IBaseButtonProps {
  active?: boolean
}

export const ButtonGroupButton = styled((props: IButtonGroupButtonProps) => (
  <BaseButton type='button' {...props} />
))`
  position: relative;

  ${(props) =>
    props.active
      ? applyButtonColorCSS(
          props.theme.colors.selected,
          props.theme.colors.content.border,
          props.theme.colors.text.primary,
          props.theme.colors.aquamarine
        )
      : applyButtonColorCSS(
          props.theme.colors.white,
          props.theme.colors.content.border,
          props.theme.colors.text.secondary,
          shade(0.05, props.theme.colors.white)
        )}

  &:hover {
    border-color: ${(props) => props.theme.colors.content.border};
  }
`

ButtonGroupButton.displayName = 'ButtonGroupButton'
